import { useMemo, useRef } from 'react';

const useHasSearchParamsChanged = (searchParams) => {
    const originalSearchParams = useMemo(() => searchParams, []);
    const hasChanged = useRef(false);

    if (!hasChanged.current) {
        hasChanged.current = originalSearchParams.toString() !== searchParams.toString();
    }
    return hasChanged.current;
};
export default useHasSearchParamsChanged;
